(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('CaptchaService', CaptchaService);

        CaptchaService.$inject = ['$resource', 'GlobalValues'];

    function CaptchaService($resource, GlobalValues) {
        var resourceUrl = 'api/';
        return $resource(resourceUrl, {}, {    	 
            'getCaptchaDetail':{
                method: 'GET',
                url: 'api/public/getCaptchaImageAndTextDetails'
            }
        });
    }
})();